'use client';
import React, { useEffect, useRef } from 'react';
import { DialogHeader } from '@src/v3/components/coreUI/dialog';
import Icon from '@src/v3/components/coreUI/icon';
import IconSection from '@src/v3/components/coreUI/iconSection';
import { LoginStepProps } from '@src/v3/interfaces/components/loginModal';
import { formatPhoneNumberWithSpaces } from '@src/v3/utils/helper';

const SuccessStep: React.FC<LoginStepProps> = ({
  phone = '',
  isOAuthFlow = false,
  onOAuthComplete,
}) => {
  const timerStartedRef = useRef<boolean>(false);

  useEffect(() => {
    if (isOAuthFlow && onOAuthComplete && !timerStartedRef.current) {
      onOAuthComplete();
    }
    return undefined;
  }, [isOAuthFlow, onOAuthComplete]);

  return (
    <>
      <DialogHeader />
      <div className="flex-1 space-y-9 flex flex-col pt-12 justify-between text-center">
        <div className="text-center flex flex-col items-center space-y-4">
          <Icon iconName="tickCircleFill" />
          <h3 className="text-2xl font-semibold text-gray-1000">Success!</h3>
          <p className="text-gray-1000 text-base leading-4">
            +1 {formatPhoneNumberWithSpaces(phone)} has been verified!
          </p>
        </div>
        <div className="">
          <IconSection
            iconName="callWhite"
            containerClassName="fixed bottom-0 left-0 right-0"
            innerContainerClassName="h-60"
            innerShadowContainerClassName="!items-start"
            iconClassName="w-14 h-14"
          />
        </div>
      </div>
    </>
  );
};

export default SuccessStep;
